var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-container"},[_c('Typography',{staticClass:"pc-sub-16 mobile-sub-14 caps"},[_vm._v(_vm._s(_vm.name))]),_c('Typography',{attrs:{"variant":"pc-title-48 mobile-title-32"}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }